import update from 'immutability-helper';
import { REQUEST_LIVE_BOOKINGS, SET_LIVE_BOOKINGS } from './live-bookings-actions';

const initialState = {
  isFetching: false,
  journeyReports: []
};

function liveBookingsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_LIVE_BOOKINGS:
      return update(state, {
        isFetching: {$set: true}
      });
    case SET_LIVE_BOOKINGS:
      return update(state, {
        journeyReports: {$set: action.payload}
      });
    default:
      return state;
  }
}

export default liveBookingsReducer;



// WEBPACK FOOTER //
// ./src/components/live-bookings/live-bookings-reducer.js